import React, { useState, useRef } from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';
import { cx } from 'linaria';
import colorsAndTextiles3DConfig from '../3D/Config/colorsAndTextiles.config.js';

// Dummy fabric data - replace with your actual fabric images
// Structure: fabricName-colorName as key
const FabricData = {
  'alis-beige': {
    name: 'Alis',
    color: 'Beige',
    placeholderColor: '#c7b88e',
  },
  'alis-brun': {
    name: 'Alis',
    color: 'Brun',
    placeholderColor: '#725833',
  },
  'alis-ljusgrå': {
    name: 'Alis',
    color: 'Ljusgrå',
    placeholderColor: '#d9dada',
  },
  'alis-mörkbeige': {
    name: 'Alis',
    color: 'Mörkbeige',
    placeholderColor: '#ac9362',
  },
  'alis-mörkbrun': {
    name: 'Alis',
    color: 'Mörkbrun',
    placeholderColor: '#472d08',
  },
  'alis-mörkgrå': {
    name: 'Alis',
    color: 'Mörkgrå',
    placeholderColor: '#5a5d61',
  },
  'alis-natur': {
    name: 'Alis',
    color: 'Natur',
    placeholderColor: '#dfca8c',
  },
  'alis-orange': {
    name: 'Alis',
    color: 'Orange',
    placeholderColor: '#ff6400',
  },
  'mito-beige': {
    name: 'Mito',
    color: 'Beige',
    placeholderColor: '#c7b88e',
  },
  'mito-brun': {
    name: 'Mito',
    color: 'Brun',
    placeholderColor: '#725833',
  },
  'mito-grå': {
    name: 'Mito',
    color: 'Grå',
    placeholderColor: '#a7a9ae',
  },
  'mito-ljusgrå': {
    name: 'Mito',
    color: 'Ljusgrå',
    placeholderColor: '#d9dada',
  },
  'mito-mörkgrå': {
    name: 'Mito',
    color: 'Mörkgrå',
    placeholderColor: '#5a5d61',
  },
  'mito-natur': {
    name: 'Mito',
    color: 'Natur',
    placeholderColor: '#dfca8c',
  },
  'mito-orange': {
    name: 'Mito',
    color: 'Orange',
    placeholderColor: '#ff6400',
  },
  'strong-beige': {
    name: 'Strong',
    color: 'Beige',
    placeholderColor: '#c7b88e',
  },
  'strong-brun': {
    name: 'Strong',
    color: 'Brun',
    placeholderColor: '#725833',
  },
  'strong-grå': {
    name: 'Strong',
    color: 'Grå',
    placeholderColor: '#a7a9ae',
  },
  'strong-ljusgrå': {
    name: 'Strong',
    color: 'Ljusgrå',
    placeholderColor: '#d9dada',
  },
  'strong-mörkbrun': {
    name: 'Strong',
    color: 'Mörkbrun',
    placeholderColor: '#472d08',
  },
  'strong-mörkgrå': {
    name: 'Strong',
    color: 'Mörkgrå',
    placeholderColor: '#5a5d61',
  },
  'strong-natur': {
    name: 'Strong',
    color: 'Natur',
    placeholderColor: '#dfca8c',
  },
  'taffie-beige': {
    name: 'Taffie',
    color: 'Beige',
    placeholderColor: '#c7b88e',
  },
  'taffie-brun': {
    name: 'Taffie',
    color: 'Brun',
    placeholderColor: '#725833',
  },
  'taffie-grå': {
    name: 'Taffie',
    color: 'Grå',
    placeholderColor: '#a7a9ae',
  },
  'taffie-ljusbrun': {
    name: 'Taffie',
    color: 'Ljusbrun',
    placeholderColor: '#876a41',
  },
  'taffie-ljusgrå': {
    name: 'Taffie',
    color: 'Ljusgrå',
    placeholderColor: '#d9dada',
  },
  'taffie-mörkbrun': {
    name: 'Taffie',
    color: 'Mörkbrun',
    placeholderColor: '#472d08',
  },
  'taffie-mörkgrå': {
    name: 'Taffie',
    color: 'Mörkgrå',
    placeholderColor: '#5a5d61',
  },
  'taffie-natur': {
    name: 'Taffie',
    color: 'Natur',
    placeholderColor: '#dfca8c',
  },
};

const BoxWrapper = styled.div`
  cursor: pointer;
  position: relative;
  font-size: 14px;
  padding-left: 2px;

  &.active {
    > div:first-child {
      outline: 3px solid #fff;
      outline-offset: -4px;
      transform: scale(1.05, 1.05);
    }
  }

  &.disabled {
    cursor: not-allowed;
    > div:first-child {
      opacity: 0.4;
      filter: grayscale(100%);
    }
  }

  &:not(.disabled):hover {
    > div:first-child {
      transform: scale(1.05, 1.05);
      transition: all 0.2s ease-in-out;
    }
    z-index: 999;
  }
`;

const FabricImage = styled.div`
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &.big {
    height: 80px;
    width: 120px;
  }

  &.medium {
    height: 60px;
    width: 90px;
    margin: 0 10px;
  }

  &.small {
    height: 40px;
    width: 60px;
    margin: 0 0.2rem;
  }
`;

// Enhanced tooltip to show availability status
const PopUpFabric = styled.div`
  position: fixed;
  z-index: 99999;
  background-color: ${theme.colors.tablegrey};
  color: ${theme.colors.black};
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 6px;
  padding: 2px 5px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  border: none;

  &.unavailable {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #ffcdd2;
  }
`;

const FabricBox = ({
  fabricName = null,
  selectedColor = null,
  clickClosure = null,
  boxsize = 'small',
  active = false,
  showLabel = false,
  disabled = false,
}) => {
  const [isShown, setIsShown] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const fabricRef = useRef(null);

  const updateTooltipPosition = () => {
    if (fabricRef.current) {
      const rect = fabricRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + 10, // 10px below the fabric box
        left: rect.left + rect.width / 2, // Center horizontally
      });
    }
  };

  const handleMouseEnter = () => {
    updateTooltipPosition();
    setIsShown(true);
  };

  const handleMouseLeave = () => {
    setIsShown(false);
  };

  const handleClick = () => {
    if (!disabled && clickClosure) {
      clickClosure();
    }
  };

  const getFabricImage = () => {
    if (!fabricName) return null;

    // If we have a selected color, try to find the specific textile for that color
    if (selectedColor) {
      // Find the color config that matches the selected color
      const colorConfig = colorsAndTextiles3DConfig.colors.find(
        (color) =>
          color.name === selectedColor || color.translation === selectedColor
      );

      if (colorConfig) {
        // Find textiles that match both the fabric and are in this color
        const matchingTextileNames = colorConfig.textiles.filter(
          (textureName) => {
            // Check if this textile name contains the fabric name
            // e.g., "Bellus-Shaff1109" contains "Shaff"
            return textureName.includes(fabricName);
          }
        );

        if (matchingTextileNames.length > 0) {
          // Find the actual textile object using the name
          const selectedTextileName = matchingTextileNames[0];
          const selectedTextile = colorsAndTextiles3DConfig.textiles.find(
            (textile) => textile.name === selectedTextileName
          );

          if (selectedTextile) {
            const imageUrl =
              boxsize === 'big'
                ? selectedTextile.bigImage
                : selectedTextile.smallImage;
            return imageUrl;
          }
        }
      }
    }

    // Fallback: just find any textile for this fabric type
    const allMatchingTextiles = colorsAndTextiles3DConfig.textiles.filter(
      (textile) => {
        return textile.fabric === fabricName;
      }
    );

    if (allMatchingTextiles.length > 0) {
      const selectedTextile = allMatchingTextiles[0];
      const imageUrl =
        boxsize === 'big'
          ? selectedTextile.bigImage
          : selectedTextile.smallImage;
      return imageUrl;
    }

    return null;
  };

  const fabricImage = getFabricImage();

  const imageStyle = fabricImage
    ? {
        backgroundImage: `url(${fabricImage})`,
      }
    : {
        backgroundColor: '#CCCCCC',
      };

  const tooltipText = disabled
    ? `${fabricName} (Ej tillgänglig i vald färg)`
    : fabricName;

  return (
    <>
      <BoxWrapper
        className={cx(active ? 'active' : null, disabled ? 'disabled' : null)}
      >
        <FabricImage
          ref={fabricRef}
          className={cx(boxsize, 'fabric-box')}
          style={imageStyle}
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {!fabricImage && (
            <span
              style={{ fontSize: '10px', textAlign: 'center', padding: '4px' }}
            >
              {fabricName}
            </span>
          )}
        </FabricImage>
      </BoxWrapper>

      {isShown && showLabel && (
        <PopUpFabric
          className={disabled ? 'unavailable' : ''}
          style={{
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`,
            transform: 'translateX(-50%)',
          }}
        >
          {tooltipText}
        </PopUpFabric>
      )}
    </>
  );
};

export default FabricBox;
